import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdateLeadSubscriptionContentMutation,
  UpdateLeadSubscriptionContentMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const updateLeadSubscriptionContentMutation = graphql(`
  mutation updateLeadSubscriptionContent($input: UpdateLeadSubscriptionContentRequest!) {
    updateLeadSubscriptionContent(UpdateLeadSubscriptionContentRequest: $input)
  }
`);

export function useUpdateLeadSubscriptionContent(
  options?: UseMutationOptions<
    UpdateLeadSubscriptionContentMutation,
    unknown,
    UpdateLeadSubscriptionContentMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(updateLeadSubscriptionContentMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptionContents"] });
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptions"] });
      options?.onSuccess && options?.onSuccess(data, variables, context);
    },
  });
  return { data: data?.updateLeadSubscriptionContent, ...rest };
}
